import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaChevronDown,
  FaPhoneAlt,
  FaEnvelope,
  FaTaxi,
} from "react-icons/fa";
import { BOOKING_URL, PHONE_TEL, PHONE_DISPLAY, EMAIL, EMAIL_MAILTO } from "../../data/config";
import "./layout.css";

const pages = [
  { to: "/work-process", label: "Work Process" },
  { to: "/gallery", label: "Gallery" },
  { to: "/testimonials", label: "Testimonials" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [mDrop, setMDrop] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    setMDrop(null);
  }, [location.pathname]);

  return (
    <>
      <div className="topbar">
        <div className="container topbar-inner">
          <div className="topbar-left">
            <a href={PHONE_TEL}><FaPhoneAlt /> {PHONE_DISPLAY}</a>
            <a href={EMAIL_MAILTO} className="hide-sm"><FaEnvelope /> {EMAIL}</a>
            <span className="hide-sm">Mon - Sun: 24/7 Service Available</span>
          </div>
          <div className="topbar-right">
            <span className="hide-sm">Fast • Safe • Affordable Taxi Service</span>
          </div>
        </div>
      </div>

      <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="container nav-inner">
          <Link to="/" className="logo">
            <span className="logo-mark"><FaTaxi /><span className="logo-badge">24/7</span></span>
            <span className="logo-text">Taxi<span>24hrs</span></span>
          </Link>

          <nav className={`nav-menu ${open ? "open" : ""}`}>
            <button
              className="nav-close"
              onClick={() => setOpen(false)}
              aria-label="Close menu"
            >
              <FaTimes />
            </button>
            <NavLink to="/" end className="nav-link">Home</NavLink>
            <NavLink to="/taxis" className="nav-link">Taxis</NavLink>
            <NavLink to="/about-us" className="nav-link">About Us</NavLink>

            <div className={`nav-dropdown ${mDrop === "pages" ? "show" : ""}`}>
              <span
                className="nav-link"
                onClick={() => setMDrop(mDrop === "pages" ? null : "pages")}
              >
                Pages <FaChevronDown />
              </span>
              <div className="dropdown-menu">
                {pages.map((p) => (
                  <NavLink key={p.to} to={p.to}>{p.label}</NavLink>
                ))}
              </div>
            </div>

            <NavLink to="/contact-us" className="nav-link">Contact</NavLink>
          </nav>

          <div className="nav-actions">
            <a href={PHONE_TEL} className="btn btn-outline nav-call" aria-label="Call Now">
              <FaPhoneAlt /> Call Now
            </a>
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary nav-cta"
            >
              Book online Now
            </a>
            <button
              className="menu-toggle"
              onClick={() => setOpen(!open)}
              aria-label="Menu"
            >
              {open ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </header>
    </>
  );
}
